import React, { useState, useEffect } from 'react';
import logo from '../../../../resources/img/logo.png';
import facebook from '../../../../resources/img/social/facebook.svg';
import instagram from '../../../../resources/img/social/instagram.svg';
import twitter from '../../../../resources/img/social/twitter.svg';
import youtube from '../../../../resources/img/social/youtube.svg';
import whatsapp from '../../../../resources/img/social/whatsapp.svg';
import clock from '../../../../resources/img/social/clock.svg';
import email from '../../../../resources/img/social/email.svg';
import { NavLink } from 'react-router-dom';

const Header = () => {
	const [pos, setPos] = useState('top');

	useEffect (()=>{
		document.addEventListener('scroll', e => {
				let scrolled = document.scrollingElement.scrollTop;
				if (scrolled >= 5){
					setPos('moved')
				} else {
					setPos('top')
				}
		})
	},[])

	return (
		<div className='header'>
			<div className={pos === 'top' ? 'social' : 'hidden'}>
				<div>
					<a href='https://api.whatsapp.com/send?phone=+34648196309' title='Chateemos por whatsapp' target="_blank">
						<img src={whatsapp} />
						<span>+34 648 196 309</span>
					</a>
					<a href='mailto:info@selo.es' title='Envíanos un email' target="_blank">
						<img src={email} />
						<span>info@selo.es</span>
					</a>
					<a className={'clock mobile-hidden'}>
						<img className='clock' src={clock} />
						<span><small>Lun-Sat</small>: 8:00 - 19:00</span>
					</a>
				</div>
				<div className='mobile-hidden'>
					<a href='https://instagram.com' title='instagram' target="_blank">
						<img className='instagram' src={instagram} />
					</a>
					<a href='https://youtube.com' title='youtube' target="_blank">
						<img className='youtube' src={youtube} />
					</a>
					<a href='https://facebook.com' title='facebook' target="_blank">
						<img className='facebook' src={facebook} />
					</a>
					<a href='https://twitter.com' title='twitter' target="_blank">
						<img className='twitter' src={twitter} />
					</a>
				</div>
			</div>
			<div className='main'>
				<div className='logo'>
					<NavLink to='/'>
						<img src={logo} />
					</NavLink>
				</div>
				<NavLink to='/quote'>
					<button>
						Calcula tu reforma
					</button>
				</NavLink>
			</div>
		</div>
	);
}

export default Header;
